module.exports = __webpack_public_path__ + "img/20230417144216.467e5f6e.png";